import {useState} from "react";
import {Check, Search} from "lucide-react";
import {CATEGORY_LABEL, money} from "@/lib/inner";

export const ServicePicker = ({services, categories, selected, onToggle, initialCategory}) => {
  const [cat, setCat] = useState(categories.includes(initialCategory) ? initialCategory : categories[0]);
  const [q, setQ] = useState("");
  const list = services.filter(s => (q ? s.name.toLowerCase().includes(q.toLowerCase()) : s.category === cat));
  return <div className="service-picker">
    <div className="cat-tabs" role="tablist">
      {categories.map(c => <button type="button" key={c} data-testid={`service-tab-${c.toLowerCase()}`} className={!q && cat === c ? "active" : ""} onClick={() => { setCat(c); setQ(""); }}>
        {CATEGORY_LABEL[c]}<i>{selected.filter(s => s.category === c).length || ""}</i>
      </button>)}
    </div>
    <div className="search picker-search"><Search/><input data-testid="service-search-input" value={q} onChange={e => setQ(e.target.value)} placeholder="Cari perawatan, misalnya: creambath"/></div>
    <div className="service-list">
      {list.map(s => {
        const on = selected.some(x => x.id === s.id);
        return <button type="button" key={s.id} data-testid={`service-option-${s.id}`} className={`service-option ${on ? "on" : ""}`} onClick={() => onToggle(s.id)}>
          <span className="check">{on && <Check size={14}/>}</span>
          <span className="svc-name">{s.name}{q && <small>{CATEGORY_LABEL[s.category]}</small>}</span>
          <span className="svc-meta"><b>{money(s.price)}</b></span>
        </button>;
      })}
      {!list.length && <p className="empty">Perawatan tidak ditemukan.</p>}
    </div>
  </div>;
};
